import { render } from "./PaiementAutreRecettesPage.vue?vue&type=template&id=5cb7cc40&ts=true"
import script from "./PaiementAutreRecettesPage.vue?vue&type=script&lang=ts"
export * from "./PaiementAutreRecettesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__